import styled from '@emotion/styled';
export const TimeStampWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: var(--spacing-4) 0 0;
  gap: var(--spacing-2);
`;
export const TimestampInput = styled.input `
  width: 60px;
  background: none;
  padding: 0;
  display: block;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid currentColor;
  color: currentColor;
  text-align: center;
  padding: calc(var(--spacing-1) / 2);
`;
export const TimeStampLabel = styled.label `
  font-size: 14px;
  user-select: none;
`;
